import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import branchActions from "../../../../store/branchStore/branchActions";
import branchApi from "../../../../store/branchStore/branchApi";
import Modal from "../../../../portals/Modal";
import PageHeader from "../../../../components/PageHeader";
import Select from "react-dropdown-select";
import TextField from "../../../../components/FormElements/TextField";
import UploadImage from "../../../ClientsDatabaseSendNotifications/UploadImage";
import { store as notificationStore } from 'react-notifications-component';
import styles from './profileBonusHeaderWhatsapp.module.scss';

const initialState = {
    text: "",
    text_for_bonus: "",
}

const initialFirstTransactionState = {
    message: "",
    bonus_amount: "",
    type: "text",
    image: null,
    image_url: null,
    buttonLinks: [{ link: '', label: '' }],
}

export default function ProfileHeaderWhatsapp() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [state, setState] = useState(initialState);
    const [firstTransactionState, setFirstTransactionState] = useState(initialFirstTransactionState);
    const [firstTransactionPending, setFirstTransactionPending] = useState(false);
    const info = useSelector((s) => s.branchReducer.info);
    const [pending, setPending] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [selectedMessageType, setSelectedMessageType] = useState({ label: t('text'), value: 'text' });
    const [botManagerContact, setBotManagerContact] = useState('');
    const [botManagerContactPending, setBotManagerContactPending] = useState(false);

    const messageTypes = useMemo(() => {
        return [
            { label: t('text'), value: 'text' },
            { label: t('file'), value: 'file' },
            { label: t('button-links'), value: 'button-links' },
        ]
    }, [i18n.language]);

    useEffect(() => {
        setState(initialState);
        setEnabled(false);

        if (info && !info.configuration.whatsapp_header) {
            return setErrorModal(true);
        }

        if (info && !info.configuration.whatsapp_header.enabled) {
            setState({
                ...state,
                custom_message: info.configuration.whatsapp_header.custom_message || '',
                text: info.configuration.whatsapp_header.text,
            });
            return setErrorModal(true);
        }

        if (info && info.configuration.whatsapp_header) {
            setState({
                ...state,
                custom_message: info.configuration.whatsapp_header.custom_message || '',
                text: info.configuration.whatsapp_header.text,
            });
            setEnabled(true);
        }

        // Load bot manager contact if it exists
        if (info && info.configuration.bot_manager_contact) {
            setBotManagerContact(info.configuration.bot_manager_contact);
        }

        // Load first transaction notification config if it exists
        if (info && info.configuration.first_transaction_notification) {
            const ftConfig = info.configuration.first_transaction_notification;
            setFirstTransactionState({
                message: ftConfig.message || "",
                bonus_amount: ftConfig.bonus_amount || "",
                type: ftConfig.type || "text",
                image: null,
                image_url: ftConfig.image_url || null,
                buttonLinks: ftConfig.button_urls && ftConfig.button_labels
                    ? ftConfig.button_urls.map((url, idx) => ({
                        link: url,
                        label: ftConfig.button_labels[idx] || ''
                    }))
                    : [{ link: '', label: '' }],
            });
            setSelectedMessageType(messageTypes.find(type => type.value === (ftConfig.type || 'text')) || messageTypes[0]);
        }
    }, [info]);

    const onChangeText = (e) => {
        if (e.target.value.length > 350) return
        setState({ ...state, text: e.target.value })
    }

    const onChangeCustomerMessage = (e) => {
        if (e.target.value.length > 350) return
        setState({ ...state, custom_message: e.target.value })
    }

    const onSubmit = (e) => {
        e.preventDefault();
        // if (state.amount <= 0) return setState({...state, errors: {...state.errors, amount: 'Заполните поле!'}});
        // if (!state.message.length) return setState({...state, errors: {...state.errors, message: 'Заполните поле!'}});
        // if (!state.message_for_week.length) return setState({...state, errors: {...state.errors, message_for_week: 'Заполните поле!'}});

        if (info) {
            setPending(true);
            new Promise((resolve, reject) => {
                const {errors, ...data} = state;
                dispatch(branchActions.changeWhatsAppHeader(info.id, { ...data, enabled }, resolve, reject));
            }).finally(() => {
                setPending(false);
                setState({ ...state });
            });
        }

    }

    const onDeactivate = (e) => {
        e.preventDefault();

        if (info) {
            setPending(true);
            new Promise((resolve, reject) => {
                const {errors, ...data} = state;
                dispatch(branchActions.updateBonusForBirthday(info.id, {
                    amount: 0,
                    message: "",
                    message_for_week: "",
                }, resolve, reject));
            })
              .then(() => {
                  dispatch(branchActions.getBranch(info.id));
              })
              .finally(() => {
                setPending(false);
                setState({...state, errors: initialState.errors});
            });
        }

    }

    const onSubmitFirstTransaction = (e) => {
        e.preventDefault();
        if (!info) return;

        setFirstTransactionPending(true);
        const formData = new FormData();

        // Add message and type
        if (firstTransactionState.message) {
            formData.append('message', firstTransactionState.message);
        }
        formData.append('type', selectedMessageType.value);

        // Add bonus amount
        if (firstTransactionState.bonus_amount) {
            formData.append('bonus_amount', Number(firstTransactionState.bonus_amount));
        }

        // Add image if type is file
        if (selectedMessageType.value === 'file' && firstTransactionState.image) {
            formData.append('image', firstTransactionState.image);
        }

        // Add button links if type is button-links
        if (selectedMessageType.value === 'button-links') {
            firstTransactionState.buttonLinks.forEach(({ label }) => formData.append('button_labels', label));
            firstTransactionState.buttonLinks.forEach(({ link }) => formData.append('button_urls', link));
        }

        branchApi.updateFirstTransactionNotification(info.id, formData)
            .then(() => {
                notificationStore.addNotification({
                    title: t('success'),
                    message: t('successfullySaved'),
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                dispatch(branchActions.getBranch(info.id));
            })
            .catch((e) => {
                notificationStore.addNotification({
                    title: t('error'),
                    message: e.response?.data?.message || t('Errors.error'),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            })
            .finally(() => {
                setFirstTransactionPending(false);
            });
    }

    const onEraseFirstTransaction = (e) => {
        e.preventDefault();
        if (!info) return;

        setFirstTransactionPending(true);
        const formData = new FormData();
        formData.append('message', '');
        formData.append('bonus_amount', 0);
        formData.append('type', 'text');

        branchApi.updateFirstTransactionNotification(info.id, formData)
            .then(() => {
                notificationStore.addNotification({
                    title: t('success'),
                    message: t('successfullyErased'),
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                setFirstTransactionState(initialFirstTransactionState);
                setSelectedMessageType(messageTypes[0]);
                dispatch(branchActions.getBranch(info.id));
            })
            .catch((e) => {
                notificationStore.addNotification({
                    title: t('error'),
                    message: e.response?.data?.message || t('Errors.error'),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            })
            .finally(() => {
                setFirstTransactionPending(false);
            });
    }

    const onSubmitBotManagerContact = (e) => {
        e.preventDefault();
        if (!info) return;

        setBotManagerContactPending(true);
        branchApi.setBotManagerContact(info.id, { bot_manager_contact: botManagerContact })
            .then(() => {
                notificationStore.addNotification({
                    title: t('success'),
                    message: t('successfullySaved'),
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                dispatch(branchActions.getBranch(info.id));
            })
            .catch((e) => {
                notificationStore.addNotification({
                    title: t('error'),
                    message: e.response?.data?.message || t('Errors.error'),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            })
            .finally(() => {
                setBotManagerContactPending(false);
            });
    }

    return (
        <div className={styles.container}>
            <PageHeader title={t('whatsappHeader')}>
                {/*<p>{t('NSBonuses.congratulate')}</p>*/}
            </PageHeader>
            <form onSubmit={onSubmit}>
                <div className={styles.p} style={{position: 'relative'}}>
                    {t('symbols350Restriction')}
                    {/*<i style={{ color: 'tomato' }}>*</i>*/}
                    {/*<div style={{position: 'absolute', left: '126px', top: '0'}}>*/}
                    {/*    <QuestionTooltip text={t('NSBonuses.pushNotification')} />*/}
                    {/*</div>*/}
                </div>
                <textarea
                  placeholder={t('Form.requiredField')}
                  value={state.text}
                  onChange={onChangeText}
                  disabled={!enabled}
                  // required
                />

                <div style={{position: 'relative', marginBottom: '1rem'}}>
                    {t('textForBonusInfo')}
                </div>
                <textarea
                  placeholder={t('text')}
                  value={state.custom_message}
                  onChange={onChangeCustomerMessage}
                  disabled={!enabled}
                  // required
                />

                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                    <ButtonFilled
                      type="submit"
                      loading={pending}
                      disabled={!enabled}
                    >{t('save')}</ButtonFilled>
                    {/*<ButtonFilled*/}
                    {/*  variant="red"*/}
                    {/*  loading={pending}*/}
                    {/*  disabled={!enabled}*/}
                    {/*  onClick={onDeactivate}*/}
                    {/*>{t('NSComparison.deactivate')}</ButtonFilled>*/}
                </div>
            </form>

            {/* First Transaction Notification Section */}
            <div style={{ marginTop: '40px', paddingTop: '40px', borderTop: '1px solid #E7E7E6' }}>
                <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>
                    {t('firstTransactionNotification')}
                </h3>
                <form onSubmit={onSubmitFirstTransaction}>
                    <div className={styles.p} style={{ marginBottom: '10px' }}>
                        {t('messageType')}
                    </div>
                    <Select
                        placeholder={t('chooseType')}
                        values={[selectedMessageType]}
                        options={messageTypes}
                        onChange={(values) => {
                            setSelectedMessageType(values[0]);
                            setFirstTransactionState({
                                ...firstTransactionState,
                                type: values[0].value,
                                image: null,
                                image_url: values[0].value === 'file' ? firstTransactionState.image_url : null,
                                buttonLinks: [{ link: '', label: '' }]
                            });
                        }}
                        style={{
                            height: 42,
                            border: '1px solid #E7E7E6',
                            borderRadius: '5px',
                            marginBottom: '20px'
                        }}
                    />

                    <div className={styles.p} style={{ marginBottom: '10px' }}>
                        {t('notificationMessage')}
                    </div>
                    <textarea
                        placeholder={t('Form.enterText')}
                        value={firstTransactionState.message}
                        onChange={(e) => {
                            if (e.target.value.length <= 1200) {
                                setFirstTransactionState({ ...firstTransactionState, message: e.target.value });
                            }
                        }}
                        style={{ width: '100%', minHeight: '100px', marginBottom: '5px' }}
                    />
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '20px' }}>
                        {firstTransactionState.message.length} / 1200 {t('symbols')}
                    </div>

                    {selectedMessageType.value === 'file' && (
                        <div style={{ marginBottom: '20px' }}>
                            <UploadImage
                                onChange={(image) => setFirstTransactionState({ ...firstTransactionState, image })}
                                image={firstTransactionState.image}
                                imageUrl={firstTransactionState.image_url}
                            />
                        </div>
                    )}

                    {selectedMessageType.value === 'button-links' && (
                        <div style={{ marginBottom: '20px' }}>
                            {firstTransactionState.buttonLinks.length < 3 && (
                                <ButtonFilled
                                    type="button"
                                    onClick={() => setFirstTransactionState({
                                        ...firstTransactionState,
                                        buttonLinks: [...firstTransactionState.buttonLinks, { link: '', label: '' }]
                                    })}
                                    style={{ marginBottom: '10px' }}
                                >
                                    {t('addLink')}
                                </ButtonFilled>
                            )}
                            {firstTransactionState.buttonLinks.map((item, index) => (
                                <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'flex-end' }}>
                                    <div style={{ flex: 1 }}>
                                        <TextField
                                            label={t('title')}
                                            value={item.label}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 25) {
                                                    setFirstTransactionState({
                                                        ...firstTransactionState,
                                                        buttonLinks: firstTransactionState.buttonLinks.map((btn, idx) =>
                                                            idx === index ? { ...btn, label: e.target.value } : btn
                                                        )
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <TextField
                                            label={t('link')}
                                            type="url"
                                            value={item.link}
                                            onChange={(e) => {
                                                setFirstTransactionState({
                                                    ...firstTransactionState,
                                                    buttonLinks: firstTransactionState.buttonLinks.map((btn, idx) =>
                                                        idx === index ? { ...btn, link: e.target.value } : btn
                                                    )
                                                });
                                            }}
                                        />
                                    </div>
                                    {index > 0 && (
                                        <ButtonFilled
                                            type="button"
                                            variant="red"
                                            onClick={() => setFirstTransactionState({
                                                ...firstTransactionState,
                                                buttonLinks: firstTransactionState.buttonLinks.filter((_, idx) => idx !== index)
                                            })}
                                        >
                                            {t('delete')}
                                        </ButtonFilled>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    <div style={{ marginBottom: '20px' }}>
                        <div className={styles.p} style={{ marginBottom: '10px' }}>
                            {t('bonusAmount')}
                        </div>
                        <TextField
                            type="number"
                            value={firstTransactionState.bonus_amount}
                            onChange={(e) => setFirstTransactionState({
                                ...firstTransactionState,
                                bonus_amount: e.target.value
                            })}
                            placeholder="0"
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <ButtonFilled
                            type="submit"
                            loading={firstTransactionPending}
                        >
                            {t('save')}
                        </ButtonFilled>
                        <ButtonFilled
                            type="button"
                            variant="red"
                            loading={firstTransactionPending}
                            onClick={onEraseFirstTransaction}
                        >
                            {t('erase')}
                        </ButtonFilled>
                    </div>
                </form>
            </div>

            {/* Bot Manager Contact Section */}
            <div style={{ marginTop: '40px', paddingTop: '40px', borderTop: '1px solid #E7E7E6' }}>
                <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>
                    Контакт для бота
                </h3>
                <form onSubmit={onSubmitBotManagerContact}>
                    <TextField
                        value={botManagerContact}
                        onChange={(e) => setBotManagerContact(e.target.value.replace(/\D/g, ''))}
                        placeholder="77769751070"
                    />
                    <div style={{ marginTop: '10px' }}>
                        <ButtonFilled
                            type="submit"
                            loading={botManagerContactPending}
                        >
                            {t('save')}
                        </ButtonFilled>
                    </div>
                </form>
            </div>

            <Modal
              open={errorModal} size="small"
              onClickClose={() => setErrorModal(false)}>
                <div className={styles.modal}>
                    <p>
                        {t('optionForbidden')} <br/>
                        {t('touchModerator')}
                    </p>
                    <div>
                        <ButtonFilled
                          onClick={() => setErrorModal(false)}
                        >{t('close')}</ButtonFilled>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
